import AuthComponent from "@components/auth/component";
import DeleteButton from "../../../components/buttons/DeleteButton";
import EditButton from "../../../components/buttons/EditButton";
import { TUserRole } from "../../../types/user-management/TUserRole";

export const userRoleColumns = (
  editHandler: (userRole: TUserRole) => void,
  deleteHandler: () => void
) => [
  {
    name: "User Role ID",
    selector: (row: TUserRole) => row.user_role_id,
    sort: true,
  },
  {
    name: "User Role Name",
    selector: (row: TUserRole) => row.user_role_name,
    sort: true,
  },
 
  {
    name: "Action",
    right: "true",
    selector: (row: TUserRole) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <AuthComponent action="edit" module="User Management" subModule="User Role">
          <EditButton
            id={row.user_role_id}
            actionHandler={() => editHandler(row)}
          />
        </AuthComponent>

        <AuthComponent action="delete" module="User Management" subModule="User Role">
          <DeleteButton id={row.user_role_id} actionHandler={deleteHandler} />
        </AuthComponent>
      </div>
    ),
  },
];
